import Wordpress, { wordPressStaticProps } from "pagecomponents/Wordpress";
import WordpressLayout from "@layouts/Wordpress";

export default function Auto({html, seo, script }) {
    return <Wordpress html={html} seo={seo} script={script} gblock />
}

export async function getStaticProps() {
    return await (wordPressStaticProps(1653))();
}

Auto.getLayout = (page) => (
    <WordpressLayout>
        {page}
    </WordpressLayout>
)